export default {
  cover_open: {
    text: '设备盖打开',
    icon: '1.png'
  },
  developer_empty: {
    text: '显影剂用完了',
    icon: '8.png'
  },
  developer_low: {
    text: '显影剂剩余少了',
    icon: '8.png'
  },
  input_tray_missing: {
    text: '纸盒未插入到设备',
    icon: '8.png'
  },
  interpreter_resource_unavailable: {
    text: '无法使用字体或窗体等解释资源',
    icon: '8.png'
  },
  marker_waste_almost_full: {
    text: '标记供应的空容器收纳部马上就要满了',
    icon: '8.png'
  },
  marker_waste_full: {
    text: '标记供应的空容器收纳部满了',
    icon: '2.png'
  },
  media_empty: {
    text: '所有纸盒缺纸',
    icon: '12-1.png'
  },
  paper_low: {
    text: '部份纸盒余量低于10%',
    icon: '11.png'
  },
  no_paper: {
    text: '部分纸盒缺纸',
    icon: '12.png'
  },
  /* media_jam: {
    text: "设备中发生了卡纸",
    icon: "5.png"
  }, */
  jam: {
    text: '设备发生卡纸',
    icon: '5.png'
  },
  opc_life_over: {
    text: '光导电体不能使用了',
    icon: '8.png'
  },
  opc_near_eol: {
    text: '光导电体的更换时期临近了',
    icon: '8.png'
  },
  other: {
    text: '检测到下列错误以外的错误',
    icon: '8.png'
  },
  output_area_full: {
    text: '有的排纸区域已经满了',
    icon: '8.png'
  },
  output_tray_missing: {
    text: '排纸托盘未插入到设备',
    icon: '8.png'
  },
  toner_empty: {
    text: '碳粉已使用完',
    icon: '9.png'
  },
  toner_low: {
    text: '墨粉剩余少了',
    icon: '7.png'
  },
  no_toner: {
    text: '缺粉',
    icon: '9.png'
  },
  success: {
    text: '正常',
    icon: '13.png'
  },
  unit_setting_error: {
    text: '检测到部分单元未正确安装。',
    icon: '3.png'
  },
  others: {
    text: '其它错误',
    icon: '8.png'
  },
  unit_replacement_necessary: {
    text: '需要更换设备',
    icon: '3.png'
  },
  waste_toner_full: {
    text: '废粉盒已满',
    icon: '2.png'
  },
  service_call: {
    text: '功能性故障(SC代码)',
    icon: '3.png'
  },
  illigal_toner_detected: {
    text: '检测到非法碳粉',
    icon: '3.png'
  },
  pm_parts_replacement_necessary: {
    text: '需要更换PM部件',
    icon: '3.png'
  },
  pm_parts_replacement_necessary_soon: {
    text: '需要尽快更换PM部件',
    icon: '3.png'
  },
  waste_toner_almost_full: {
    text: '废粉盒即将堆满',
    icon: '2.png'
  },
  toner_almost_empty: {
    text: '碳粉余量不足',
    icon: '7.png'
  },
  off_line: {
    text: '设备离线',
    icon: '5.png'
  },
  photo_media_empty: {
    text: '冲印设备-纸盒缺纸',
    icon: '12.png'
  },
  photo_jam: {
    text: '冲印设备-卡纸',
    icon: '5.png'
  },
  photo_cover_open: {
    text: '冲印设备-盖板打开',
    icon: '1.png'
  },
  photo_other: {
    text: '冲印设备-其它错误',
    icon: '8.png'
  },
  photo_toner_low: {
    text: '冲印设备-墨粉不足',
    icon: '7.png'
  },
  photo_no_toner: {
    text: '冲印设备-缺粉',
    icon: '9.png'
  }
}
